<script>
import Repositories from '@/repositories';
const ItemSuppliersRepository = Repositories.get('itemsuppliers');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import PriceHistoriesModal from './modals/prices-history.vue';
import GridComponent from '@/components/widgets/grids/pagination-grid';

/**
 * Dashboard Component
 */
export default {
  props: {
    itemIdPublic: String,
  },
  components: {
    Loading,
    PriceHistoriesModal,
    GridComponent,
  },
  data() {
    return {
      isLoading: false,
      itemSuppliersList: [],
      popoverShow: false,
      itemSupplierModalIdPublic: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      ItemSuppliersRepository.customREST
        .getByItem(this.itemIdPublic)
        .then((response) => {
          this.itemSuppliersList = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    showPriceHistoriesModal(itemSupplierIdPublic) {
      this.itemSupplierModalIdPublic = itemSupplierIdPublic;
      this.$bvModal.show('price-histories-modal');
    },
    modalClosed() {
      this.itemSupplierModalIdPublic = null;
    },
    closePopover() {
      this.popoverShow = false;
    },
  },
  computed: {
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
    fieldsComputed() {
      return [
        {
          key: 'isDefaultSupplier',
          label: this.$t('general.default'),
          class: 'centered-field max-100',
          tdClass: 'max-100',
          sortable: true,
        },
        {
          key: 'supplierName',
          label: this.$t('suppliers.supplierName'),
          sortable: true,
        },
        {
          key: 'code',
          label: this.$t('suppliers.supplierCode'),
          sortable: true,
        },
        {
          key: 'price',
          label: this.$t('items.price'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'link',
          label: this.$t('general.link'),
          tdClass: 'max-100',
          class: 'centered-field',
          sortable: true,
        },
      ];
    },
    listComputed() {
      return this.itemSuppliersList.map((x) => {
        return { ...x, link: this.addHttps(x.link) };
      });
    },
  },
};
</script>

<template>
  <div v-if="currencyFormatter != null">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <GridComponent
      id="item-suppliers-grid"
      :fields="fieldsComputed"
      :items="listComputed"
      :per-page="5"
      :border="true"
    >
      <template #cell(isDefaultSupplier)="data">
        <i
          v-if="data.item.isDefaultSupplier"
          class="fas fa-check text-success"
          style="font-size: 1.2em"
        >
        </i>
        <i
          v-else
          class="fas fa-check text-secondary pl-2 pr-2"
          style="font-size: 1.2em"
        >
        </i>
      </template>
      <template #cell(link)="data">
        <a :href="data.item.link">
          <i class="fas fa-link"></i>
        </a>
      </template>
      <template #cell(price)="data">
        <div
          cols="3"
          class="text-center clickable-text flex-vertical-align"
          @click="showPriceHistoriesModal(data.item.idPublic)"
        >
          {{ currencyFormatter.format(data.item.price) }}
        </div>
      </template>
    </GridComponent>

    <PriceHistoriesModal
      :itemSupplierIdPublic="itemSupplierModalIdPublic"
      @modal-closed="modalClosed"
    />
  </div>
</template>

<style scoped>
.supplier-box {
  border: 1px solid #ced4da;
  border-radius: 5px;
  min-height: 200px;
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: hidden;
}
.supplier-row {
  padding-right: 8px;
  padding-left: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.scolling-row {
  min-height: 160px;
  max-height: 160px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>